<template>
    <b-modal id="site-review-modal" ref="site-review-modal" :title="`Leave a visit report for ${site.name}`" :ok-disabled="$v.$invalid" @ok="okModal" size="xl">
        <b-form v-if="state == 'idle'" @submit="save">
            <b-form-group
                label="Visit Date"
                label-for="visit_date"
            >
                <ProgressiveDatePicker v-model="$v.form.visit_date.$model" value-as-string :class="{ 'is-invalid': $v.form.visit_date.$invalid }" />
                <div class="invalid-feedback" v-if="$v.form.visit_date.$invalid">At least a month and year are required</div>
            </b-form-group>
            
            <b-form-group
                label="Review"
                label-for="review"
            >
                <b-form-textarea
                    id="review"
                    v-model.trim="$v.form.review.$model"
                    placeholder="Add your review ..."
                    rows="3"
                    max-rows="6"
                    :class="{ 'is-invalid': $v.form.review.$error }"
                ></b-form-textarea>
                <div class="invalid-feedback" v-if="$v.form.review.$error">Review is required and must be at least 10 characters</div>
            </b-form-group>
            
            <h3>My Rating and Attributes</h3>
            <p class="text-muted">Updating these will update your overall rating for {{ site.name }}.</p>
            <div class="row">
                <div class="col-lg mb-4">
                    <RatingChart :editable="true" :ratings="form.my_ratings" @change="ratingChanged" table-class="mx-auto mx-lg-0" />
                </div>
                
                <div class="col-lg-8 col-xl-9">
                    <AttributeEditor v-model="form.my_environmental_attributes" />
                </div>
            </div>
            
            <p class="mt-4"><small>Please only review hot springs that you have visited and have meaningful knowledge of. Abusive reviews will be removed.</small></p>
        </b-form>
        
        <div v-else>
            <div>
                <div class="spinner-grow spinner-grow-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                Saving ...
            </div>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import RatingChart from "@/components/elements/RatingChart"
import ProgressiveDatePicker from "@/components/form-controls/ProgressiveDatePicker"
import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import minLength from 'vuelidate/lib/validators/minLength'
import alphaDash from '@/vuelidate/alphaDash'
import GAMixins from '@/mixins/GAMixins'
import AttributeEditor from "@/components/elements/AttributeEditor"

export default {
    name: 'SiteReviewModal',
    mixins: [
        validationMixin,
        GAMixins,
    ],
    components: {
        RatingChart,
        AttributeEditor,
        ProgressiveDatePicker,
    },
    validations: {
        form: {
            review: {
                required,
                minLength: minLength(10),
            },
            visit_date: {
                required,
                alphaDash,
            }
        },
    },
    props: {
        site: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default() {
                return false
            }
        },
    },
    data() {
        return {
            state: 'idle',
            form: {
                visit_date: null,
                review: '',
                my_ratings: this.site.my_ratings,
                my_environmental_attributes: this.site.my_environmental_attributes,
            },
        }
    },
    computed: {
        ...mapState('account', ['userProfile']),
    },
    watch: {
        active(newVal) {
            if (newVal) {
                this.$refs['site-review-modal'].show()
            } else {
                this.$refs['site-review-modal'].hide()
            }
        },
    },
    methods: {
        okModal(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.save()
        },
        save() {
            this.gaTrackInteraction('Save Review', this.site.name)
            axios({
                url: process.env.VUE_APP_API_BASE_URL + '/sites/' + this.site.slug + '/reviews',
                method: 'POST',
                data: this.form,
            }).then(response => {
                console.log(response)
                this.$emit('change', response.data)
                this.$refs['site-review-modal'].hide()
            }).catch(error => {
                console.log({ error: error })
            })
        },
        ratingChanged(key, rating) {
            this.form.my_ratings[key] = rating
        },
        show() {
            this.$refs['site-review-modal'].show()
        },
    },
    mounted() {
        if (this.active) {
            this.$refs['site-review-modal'].show()
        }
    },
};
</script>

<style lang="scss"></style>